<script>
    import Payment from '@/online_booking/new/components/common_booking/Payment.vue';
    import ChooseGiftcard from '@/online_booking/new/components/gift_cards/ChooseGiftcard.vue';
    import FillInformationGiftcard from '@/online_booking/new/components/gift_cards/FillInformationGiftcard.vue';
    import GiftcardPurchaseSuccess from '@/online_booking/new/components/gift_cards/GiftcardPurchaseSuccess.vue';
    import OnlineBookingSidebarSteps from '@/online_booking/new/components/common/OnlineBookingSidebarSteps.vue';
    import { http } from '@/system/http.js';
    import store from '@/online_booking/new/store';
    import { mapActions } from 'vuex';
    import { bookingModules } from '@/online_booking/new/helpers/constants';

    export default {
        data() {
            return {
                show_confirmation: false,
                online_booking_settings: null,
                user: null,
                logged_in_client: false,
                loading: false,
                permalink: permalink,
                gmaps_url: null,
            }
        },

        components: {
            Payment,
            ChooseGiftcard,
            FillInformationGiftcard,
            GiftcardPurchaseSuccess,
            OnlineBookingSidebarSteps,
        },

        beforeMount() {
            this.setCurrentModule(bookingModules.BOOK_GIFT_CARD);
        },

        mounted() {
            this.init();

            this.$event_bus.$on('finish', () => {
                this.show_confirmation = true;
            })
        },

        beforeUnmount() {
            this.$event_bus.$off('finish');
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentModule']),

            init() {
                store.commit('clearProducts');

                this.loading = true;

                http.get('/book/' + this.permalink + "/get")
                    .then(({ data }) => {
                        this.online_booking_settings = data.online_booking_settings;
                        this.user = data.user;
                        this.gmaps_url = data.gmaps_url;
                        this.logged_in_client = data.logged_in_client;
                        this.loading = false;
                        this.$event_bus.$emit('LoadData', data);
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },
        },
    };


</script>


<template id="subpage-online-booking">
    <div>
        <div class="text-center" v-if="loading">
            <div class="preloader"></div>
        </div>

        <div v-show="!loading">
            <div class="row">
                <online-booking-sidebar-steps
                    class="col-md-4"
                    v-show="!show_confirmation"
                    :title="trans('online_booking.gift_cards.title')"
                />

                <div
                    class="panel-group col-md-8"
                    id="booking-accordion"
                    role="tablist"
                    aria-multiselectable="false"
                    v-show="!show_confirmation"
                >
                    <choose-giftcard></choose-giftcard>
                    <fill-information-giftcard></fill-information-giftcard>
                    <payment></payment>
                </div>

            </div>

            <transition name="slideUpConfirm">
                <giftcard-purchase-success v-show="show_confirmation"></giftcard-purchase-success>
            </transition>
        </div>
    </div>


</template>
